export default {
  methods: {
    isElementTooLong(element) {
      return element && element.scrollWidth !== element.offsetWidth;
    },
  },
};
